import { render } from "./GerenciamentoMenu.vue?vue&type=template&id=340e27c7&scoped=true"
import script from "./GerenciamentoMenu.vue?vue&type=script&lang=js"
export * from "./GerenciamentoMenu.vue?vue&type=script&lang=js"

import "./GerenciamentoMenu.vue?vue&type=style&index=0&id=340e27c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340e27c7"]])

export default __exports__